export default __webpack_public_path__ + "static/media/contact.483ce3cc.jpeg";